module.exports = __webpack_public_path__ + "static/media/Claire Paddison.f5ecb721.png";